import { useNotificationsPopoverControl } from '@/app-shell/layout/Navigation/notifications/notifications-popover-focus';
import { useSettingsModal } from '@/app-shell/settings/hooks/useSettingsModal';
import { useCallback } from 'react';

/**
 * The port both compliance-row placements hand the card behind the
 * `@heidi/growth` door. The popover to dismiss, the focus return to suppress
 * and the analytics source are this surface's, so they stay here.
 */
export const useOpenComplianceSettings = (): ((settingsRoute: string) => void) => {
  const { open: openSettingsModal } = useSettingsModal();
  const { skipFocusReturn, close: closePopover } = useNotificationsPopoverControl();

  return useCallback(
    (settingsRoute: string) => {
      skipFocusReturn();
      closePopover();
      openSettingsModal(settingsRoute, 'notification_card');
    },
    [closePopover, openSettingsModal, skipFocusReturn]
  );
};
